import { AppStoreConfig } from "@intrasync/stores";
import { qualityControlAppStores } from "@intrasync/quality-control";

/**
 * View stores from `@intrasync/quality-control`: `qcHubStore` (hub view state),
 * `qcHubDataStore` (hub data) and `inspectionCaptureStore` (capture flow).
 *
 * Replaces the five bespoke stores that backed the retired screens
 * (QualityControlStore, QCInspectorDashboardStore, QCManagerDashboardStore,
 * QCInspectionStore, QCApprovalStore). Each class is instantiated as
 * `new Store(rootStore)` by RootStore, which is the shape the module ships.
 */
// The package types `store` as `unknown` (it is deliberately agnostic about the
// host's store base class); the host's AppStoreConfig wants the constructor. The
// shapes are identical at runtime — RootStore calls `new Store(rootStore)` either
// way — so this is the same structural bridge the designer and yard routes use.
const qualityControlStoreList =
  qualityControlAppStores as unknown as AppStoreConfig[];

export default qualityControlStoreList;
